import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, timer } from 'rxjs';

const appName = '0account';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private documentTitle = inject(Title);
  private title = new BehaviorSubject<string>('');

  title$ = this.title.asObservable();

  setTitle(title: string): void {
    // Deferred so a page can set its title during init without tripping
    // "expression changed after it was checked" in the shell that shows it.
    timer(0).subscribe(() => {
      this.title.next(title);
      this.documentTitle.setTitle(title ? `${title} · ${appName}` : appName);
    });
  }

  getTitle(): string {
    return this.title.value;
  }
}
